import { pick } from './i18n.js';

const zh = {
  login: { storyHeading: '把灵感，\n一步步变成设计。', storyBody: '参考、批注和每一次迭代，\n都留在同一个工作空间里。', sketchReference: '参考与观察', sketchDesign: '探索新的可能', sketchIteration: '保留意图，继续迭代', submit: '进入工作台 →', backHome: '← 返回首页', welcome: '欢迎回来', description: '登录你的 AiMo 项目空间。', account: '账号', password: '密码', unavailable: '登录服务暂时不可用，请联系管理员。', incomplete: '登录未完成。' },
  dismissNotice: '点击关闭此提示',
  incompleteAction: '操作未完成，请稍后重试。',
  invalidAuthorization: '授权链接无效，请回到执行端重新登录。',
  canvas: '设计画布',
  preparing: '正在准备工作台…',
  wrongProject: '链接中的画布不属于该项目。',
  legacyLink: '旧的画布节点或任务链接已停止支持，已打开所属项目画布；请从画布复制新的资源链接。',
  eyebrow: 'YOUR DESIGN, IN CONTEXT',
  referenceTitle: 'REFERENCE',
  designTitle: 'DESIGN',
  iterationTitle: 'ITERATION 02',
  welcomeTitle: 'WELCOME BACK',
};
const en: typeof zh = {
  login: { storyHeading: 'Turn inspiration\ninto design, step by step.', storyBody: 'References, notes and every iteration\nstay in one workspace.', sketchReference: 'Reference and observe', sketchDesign: 'Explore what is possible', sketchIteration: 'Keep the intent, keep iterating', submit: 'Enter workspace →', backHome: '← Back to home', welcome: 'Welcome back', description: 'Sign in to your AiMo project space.', account: 'Account', password: 'Password', unavailable: 'Sign-in is unavailable right now. Contact your administrator.', incomplete: 'Sign-in did not finish.' },
  dismissNotice: 'Click to dismiss this notice',
  incompleteAction: 'The action did not complete. Try again later.',
  invalidAuthorization: 'The authorization link is invalid. Return to the execution device and sign in again.',
  canvas: 'Design canvas',
  preparing: 'Preparing workbench…',
  wrongProject: 'The linked canvas does not belong to this project.',
  legacyLink: 'Old canvas node and task links are no longer supported. The project canvas is open; copy a new resource link from it.',
  eyebrow: 'Your design, in context',
  referenceTitle: 'Reference',
  designTitle: 'Design',
  iterationTitle: 'Iteration 02',
  welcomeTitle: 'Welcome back',
};
export const appTextByLocale = { zh, en };
export const appText = pick<typeof zh>(appTextByLocale);
